import {
  hondaStorageFileRequestSchema,
  type HondaStorageFileRequest,
} from './hondaStorageFileRequestSchema';

export const importHondaPartsPriceListMessageInputSchema = hondaStorageFileRequestSchema;

export type ImportHondaPartsPriceListMessageInput = HondaStorageFileRequest;
